<template>
  <div class="block25">
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">
        <span class="arrow"></span>返回首页
      </router-link>
    </div>
    <!-- 返回 -->
    <!-- 内容 -->
    <div class="container">
      <h2 class="title1" id="qdlt">驱动链条</h2>
      <div class="container-content">
        <p class="text_line">检查驱动链条是否松弛</p>
        <p>
          在链条的多个位置检查驱动链条垂度。如果各个位置的垂度不一致，则说明链条可能会纽绞或卡滞。
          <br />让经销商对您的摩托车进行检查
        </p>
        <ul class="numberspace">
          <li>
            <em>1</em>将变速器置于空档，熄灭发动机。
          </li>
          <li>
            <em>2</em>使用中心支架将摩托车停在坚固、平坦的地面上。
          </li>
          <li>
            <em>3</em>在链轮之间的中央检查驱动链条下部的垂度。
            <ul class="triangle">
              <li>如果垂度超过50mm，请勿驾驶您的摩托车。</li>
            </ul>
          </li>
          <table class="inside"><tr><td class="textLeft"><strong>驱动链条垂度：</strong><br>25至35mm</td></tr></table>
          <img src="./img/img1.jpg" width="100%" />
          <li>
            <em>4</em>转动后轮，检查链条是否平滑运行。
          </li>
          <li>
            <em>5</em>
            <router-link to="/block18/qudong">检查链齿轮</router-link>。
          </li>
          <li>
            <em>6</em>
            <router-link to="/block18/qingjie">清洁和润滑驱动链条</router-link>。
          </li>
        </ul>
        <p class="text_line" id="chuidu">调整驱动链条松紧</p>
        <p>调节链条需要专用工具。<br>让经销商对驱动链条垂度进行调节。</p>
        <ul class="numberspace">
          <li>
            <em>1</em>将变速杆调至N档（空档），停止发动机。
          </li>
          <li>
            <em>2</em>将摩托车停在坚固、平坦的路面上。
          </li>
          <li>
            <em>3</em>松开后轴螺母。
          </li>
          <li>
            <em>4</em>拧松摇臂两侧的锁紧螺母。
          </li>
          <img src="./img/img2.jpg" width="100%" />
           <img src="./img/img3.jpg" width="100%" />
          <li>
            <em>5</em>将两个调节螺母旋转相同圈数，直至获得适宜的链条垂度。顺时针转动调节螺母可拉紧链条。逆时针转动调节螺母可让链条更松弛。
            <br />调节驱动链轮和从动链轮中间的垂度。
            <br />检查驱动链条松弛。
          </li>
          <li>
            <em>6</em>通过确定链条调节索引标记对准调整槽的后缘，检查后轴线。
            <br />两个标记应吻合。如果轴没有对齐，转动左右调节螺母，直到标记对准，并重新检查链条松紧。
          </li>
          <li>
            <em>7</em>拧紧后轮轴螺母。
            
          </li>
          <table class="inside"><tr><td class="textLeft"><strong>扭矩：</strong><br>88 N·m</td></tr></table>
          <li>
            <em>8</em>固定调节螺母，拧紧锁紧螺母。
          </li>
          <li>
            <em>9</em>检查驱动链条的松紧。
          </li>
        </ul>
        <p>
          如果不使用扭矩扳手来安装，请尽快让您的经销商核实正确的装配。
          <br />装配不当会导致制动能力的丧失。
        </p>
        <p class="text_square">检查驱动链条的磨损</p>
        <p>
          如果后轮轴移动到所调整的最远位置，说明驱动链条松弛过度，必须更换新的驱动链条。
          <br />
          <table class="inside"><tr><td class="textLeft"><strong>链条规格：</strong><br>428HDF-132</td></tr></table>
          <br />如果有必要的话，联系经销商更换新的驱动链条。
        </p>
      </div>
      <div class="foot-btn">
        <div class="prev">
          <router-link to="/block24">上一页</router-link>
        </div>
        <div class="next">
          <router-link to="/block26">下一页</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>